export const ASSETS = {
  "backgrounds": {
    "table": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/backgrounds/table.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    }
  },
  "chips": {
    "chip_1": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/chips/chip_1.png",
      "height": 60,
      "transparent": true,
      "width": 60
    },
    "chip_10": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/chips/chip_10.png",
      "height": 60,
      "transparent": true,
      "width": 60
    },
    "chip_100": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/chips/chip_100.png",
      "height": 60,
      "transparent": true,
      "width": 60
    },
    "chip_25": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/chips/chip_25.png",
      "height": 60,
      "transparent": true,
      "width": 60
    },
    "chip_5": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/chips/chip_5.png",
      "height": 60,
      "transparent": true,
      "width": 60
    },
    "chip_500": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/main/preview/assets/chips/chip_500.png",
      "height": 60,
      "transparent": true,
      "width": 60
    }
  },
  "game": {
    "rouletteBall": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/99f8a146ec0249f7bcc9a5779df54db9/preview/assets/game/rouletteBall.png",
      "width": 32,
      "height": 32,
      "transparent": true
    },
    "rouletteWheel": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/aaf9d82dbe1b4430b49c7ac33e8dcd9a/99f8a146ec0249f7bcc9a5779df54db9/preview/assets/game/rouletteWheel.png",
      "width": 600,
      "height": 600,
      "transparent": true
    }
  }
}